export default {
  preview: {
    label: 'Forhåndsvisning',
    tooltip: 'Forhåndsvis onlinebestillingssiden i en ny fane.',
  },
  buttons: {
    visit_online_store: 'Onlinebutik',
  },
  toasts: {
    failed_to_launch_orders_portal_app: 'Kunne ikke starte ordreportalen',
  },
};
